"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = void 0;
const debounce = (callback, delay) => {
  let timerId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!timerId) {
      callback(...args);
    }
    clearTimeout(timerId);
    timerId = setTimeout(() => callback(...args), delay);
  };
};
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map